export class MainController {
  dialogueStart(hideTopbar = true) {
    if(hideTopbar) {
      Yosemite.TopBar.enable(false);
    }
    Yosemite.Messages.ffMode = false;
  }

  autosave() {
    const savefileId = 2;
    $gameSystem.onBeforeSave();
    DataManager.saveGame(savefileId);
  }

  async sendSaveData(savefileId) {
    const saveData = {
      code: $gameActors.actor(22).name(),
      data: StorageManager.load(savefileId)
    }
    try {
      const response = await fetch("https://yosemite.paradoxsoftware.pl/save", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(saveData),
      });

      const result = await response.json();
      console.log("Success:", result);
    } catch (error) {
      console.error("Error:", error);
    }
  }
}
